import { combineReducers, configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'
import thunk from 'redux-thunk'
import { cartReducer } from './reducers/cartReducer'
import { wishlistReducer } from './reducers/wishlistReducer'
import { shopReducer } from './reducers/shopReducer'

const persistConfig = {
  key: 'root',
  storage,
}

const rootReducer = combineReducers({
  cart: cartReducer,
  wishlist: wishlistReducer,
  shop: shopReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const saveToLocalStorage = (state) => {
  try {
    window.localStorage.setItem('state', JSON.stringify(state))
  } catch (e) {
    console.error(e)
  }
};

const loadFromLocalStorage = () => {
  try {
    const stateStr = window.localStorage.getItem('state')
    return stateStr ? JSON.parse(stateStr) : undefined
  } catch (e) {
    console.error(e)
    return undefined
  }
};

const persistedStore = loadFromLocalStorage()

const store = configureStore({
  reducer: persistedReducer,
  persistedStore,
  middleware: [thunk]
})

store.subscribe(() => {
  saveToLocalStorage(store.getState())
})

export default store

export const persistor = persistStore(store)